/**
 * Shop by Room — Tracking (shop-by-room-tracking.js)
 * NOT room-gallery-tracking.js (legacy, never reuse).
 * Fires dataLayer events for GTM → GA4 property 294491314.
 */
(function () {
  'use strict';

  var ROOM_MAP = {
    'kitchen': 'Kitchen', 'dining-room': 'Dining Room', 'bathroom': 'Bathroom',
    'bedroom': 'Bedroom', 'living-room': 'Living Room', 'entryway': 'Entryway',
    'hallway': 'Hallway', 'home-office': 'Home Office', 'outdoor': 'Outdoor'
  };

  var STYLE_MAP = {
    'modern': 'Modern', 'farmhouse': 'Farmhouse', 'transitional': 'Transitional',
    'contemporary': 'Contemporary', 'coastal': 'Coastal', 'industrial': 'Industrial',
    'mid-century': 'Mid-Century', 'glam': 'Glam', 'traditional': 'Traditional'
  };

  // Handles that break the room-first pattern (fixed 2026-09-20).
  // Bathroom style pages are style-first; Dining style pages use 'dining-', not 'dining-room-'.
  // Without these the parser finds no room and the script exits silently (no page view, no tile clicks).
  var HANDLE_OVERRIDES = {
    'modern-bathroom-lighting':       ['bathroom', 'modern'],
    'transitional-bathroom-lighting': ['bathroom', 'transitional'],
    'contemporary-bathroom-lighting': ['bathroom', 'contemporary'],
    'coastal-bathroom-lighting':      ['bathroom', 'coastal'],
    'dining-modern-lighting':         ['dining-room', 'modern'],
    'dining-transitional-lighting':   ['dining-room', 'transitional'],
    'dining-contemporary-lighting':   ['dining-room', 'contemporary'],
    'dining-mid-century-lighting':    ['dining-room', 'mid-century'],
    'dining-traditional-lighting':    ['dining-room', 'traditional']
  };

  function parseHandle() {
    var path = window.location.pathname;
    var match = path.match(/\/collections\/([^/?#]+)/);
    if (!match) return { room: null, style: null };
    var handle = match[1];
    var room = null, style = null;
    var override = HANDLE_OVERRIDES[handle];
    if (override) return { room: ROOM_MAP[override[0]], style: STYLE_MAP[override[1]] };
    var roomKeys = Object.keys(ROOM_MAP).sort(function(a, b) { return b.length - a.length; });
    for (var i = 0; i < roomKeys.length; i++) {
      var slug = roomKeys[i];
      if (handle.indexOf(slug + '-') === 0 || handle === slug + '-lighting') {
        room = ROOM_MAP[slug];
        var remainder = handle.slice(slug.length + 1).replace(/-lighting$/, '');
        if (remainder && STYLE_MAP[remainder]) style = STYLE_MAP[remainder];
        break;
      }
    }
    return { room: room, style: style };
  }

  var parsed = parseHandle();
  if (!parsed.room) return;

  window.dataLayer = window.dataLayer || [];

  // EVENT 1: Page view
  window.dataLayer.push({
    event: 'shop_by_room_page_view',
    sbr_room: parsed.room,
    sbr_style: parsed.style || 'all'
  });

  // EVENT 2 + 3: Click delegation
  document.addEventListener('click', function (e) {

    // Style chip click — selector: a.rg-chip
    var chip = e.target.closest('a.rg-chip');
    if (chip) {
      var href = chip.getAttribute('href') || '';
      var toStyle = 'all';
      var styleKeys = Object.keys(STYLE_MAP);
      for (var i = 0; i < styleKeys.length; i++) {
        if (href.indexOf(styleKeys[i]) !== -1) { toStyle = STYLE_MAP[styleKeys[i]]; break; }
      }
      window.dataLayer.push({
        event: 'shop_by_room_filter_click',
        sbr_room: parsed.room,
        sbr_style_from: parsed.style || 'all',
        sbr_style_to: toStyle
      });
      return;
    }

    // Tile click — selector: a.rg-tile__link (inside article.rg-tile)
    var tileLink = e.target.closest('a.rg-tile__link');
    if (tileLink) {
      var article = tileLink.closest('article.rg-tile');
      var sku = article ? (article.getAttribute('data-sku') || '') : '';
      var tileStyle = article ? (article.getAttribute('data-style') || '') : '';

      // Position = 1-based index among all visible tiles
      var allTiles = document.querySelectorAll('article.rg-tile');
      var position = 0;
      for (var j = 0; j < allTiles.length; j++) {
        if (allTiles[j] === article) { position = j + 1; break; }
      }

      window.dataLayer.push({
        event: 'shop_by_room_tile_click',
        sbr_room: parsed.room,
        sbr_style: parsed.style || 'all',
        sbr_sku: sku,
        sbr_tile_style: tileStyle,
        sbr_position: String(position),
        sbr_image_url: (function() {
          var img = article ? article.querySelector('img') : null;
          return img ? (img.src || img.dataset.src || '') : '';
        })(),
        sbr_image_filename: (function() {
          var img = article ? article.querySelector('img') : null;
          var src = img ? (img.src || img.dataset.src || '') : '';
          var match = src.match(/\/([^\/?#]+)(?:\?|$)/);
          return match ? match[1] : '';
        })()
      });

      // Append referral context to tile link for cross-surface attribution
      var refSep = tileLink.href.indexOf('?') > -1 ? '&' : '?';
      tileLink.href += refSep + 'img_ref=sbr'
        + '&img_room=' + encodeURIComponent(parsed.room)
        + '&img_style=' + encodeURIComponent(parsed.style || 'all')
        + '&img_sku=' + encodeURIComponent(sku);
      return;
    }
  });
})();
